"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const MapProviderCardList_styles_1 = require("./MapProviderCardList.styles");
const MapProviderCard_1 = require("../MapProviderCard");
const MapProviderCardList = (_a) => {
    var { providers, 'data-testid': testId, onEscape } = _a, rest = __rest(_a, ["providers", 'data-testid', "onEscape"]);
    const itemRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = itemRefs.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const handleKeyDown = (0, react_1.useCallback)((event, currentIndex) => {
        var _a;
        const { key } = event;
        let targetIndex = currentIndex;
        switch (key) {
            case 'ArrowDown':
                event.preventDefault();
                targetIndex = Math.min(currentIndex + 1, providers.length - 1);
                break;
            case 'ArrowUp':
                event.preventDefault();
                targetIndex = Math.max(currentIndex - 1, 0);
                break;
            case 'Home':
                event.preventDefault();
                targetIndex = 0;
                break;
            case 'End':
                event.preventDefault();
                targetIndex = providers.length - 1;
                break;
            case 'Escape':
                event.preventDefault();
                onEscape === null || onEscape === void 0 ? void 0 : onEscape();
                return;
            default:
                return;
        }
        if (targetIndex !== currentIndex && itemRefs.current[targetIndex]) {
            (_a = itemRefs.current[targetIndex]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [providers.length, onEscape]);
    return (react_1.default.createElement(MapProviderCardList_styles_1.ListContainer, Object.assign({ "data-testid": testId, role: "list" }, rest), providers.map((providerProps, index) => {
        var _a;
        return (react_1.default.createElement(MapProviderCardList_styles_1.ProviderCardItem, { key: ((_a = providerProps.provider) === null || _a === void 0 ? void 0 : _a.id) || index, ref: (el) => (itemRefs.current[index] = el), "data-testid": "provider-card-item", role: "listitem", tabIndex: 0, onKeyDown: (event) => handleKeyDown(event, index) },
            react_1.default.createElement(MapProviderCard_1.MapProviderCard, Object.assign({}, providerProps))));
    })));
};
exports.default = MapProviderCardList;
//# sourceMappingURL=MapProviderCardList.js.map